import { Graphics, Point } from 'pixi.js-legacy';
import Constants from '../constants';
export class JoistOptions {
    constructor() {
        this.id = '';
        this.beamDirection = Constants.vertical;
        this.startPosition = new Point(0, 0);
        this.endPosition = new Point(0, 0);
        this.chosenSection = '';
    }
}
export class Joist extends Graphics {
    constructor(options = new JoistOptions()) {
        super();
        this.chosenSection = options.chosenSection;
        this.name = 'Joist';
        this.id = options.id;
        this.beamDirection = options.beamDirection;
        this.startPosition = options.startPosition;
        this.endPosition = options.endPosition;
        this.draw();
    }
    draw() {
        this.clear();
        this.lineStyle(4, 0xffa500, 1);
        const dashLength = 16;
        let sX = this.startPosition.x;
        let sY = this.startPosition.y;
        const eX = this.endPosition.x;
        const eY = this.endPosition.y;
        this.moveTo(sX, sY);
        const dX = eX - sX;
        const dY = eY - sY;
        const dashes = Math.floor(Math.sqrt(dX * dX + dY * dY) / dashLength);
        const dashX = dX / dashes;
        const dashY = dY / dashes;
        let q = 0;
        while (q++ < dashes) {
            sX += dashX;
            sY += dashY;
            if (q % 2 === 0) {
                this.moveTo(sX, sY);
            }
            else {
                this.lineTo(sX, sY);
            }
        }
        if (q % 2 === 0) {
            this.moveTo(sX, sY);
        }
        else {
            this.lineTo(sX, sY);
        }
    }
}
